import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {DynamicPercentInput} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicPercentInput';

export {DynamicPercentInput};
export default connectDynamic(DynamicPercentInput);
